// Azure AD Configuration for SSO authentication
export const msalConfig = {
    auth: {
        clientId: `${process.env.REACT_APP_AAD_CLIENT_ID}`,
        authority: `${process.env.REACT_APP_AAD_AUTHORITY}`,
        redirectUri: window.location.origin + '/',
        postLogoutRedirectUri: window.location.origin + '/',
        navigateToLoginRequestUrl: true        
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                // Only log errors and warnings, not info messages
                if (level <= 1) { // 0 = Error, 1 = Warning
                    console.log(`[MSAL ${level}]: ${message}`);
                }
            },
            logLevel: 1, // Only errors and warnings
        },
    }    
};

export const loginRequest = {
    scopes: [
        'user.read',
        'profile',
        'openid',
        'email'
    ],
    prompt: 'select_account'
};
